/**
 * @file Transaction filter actions.
 */

export const UPDATE_FILTER = 'transaction-filter/UPDATE_FILTER';
export const RESET_FILTER = 'transaction-filter/RESET_FILTER';

export const updateFilter = filter => {
  return { type: UPDATE_FILTER, filter };
};

export const resetFilter = () => {
  return { type: RESET_FILTER };
};
